import { Condiciones_otras } from './../../../models/condiciones_otras.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import * as moment from 'moment';

@Component({
  selector: 'app-otras-solicitudes',
  templateUrl: './otras-solicitudes.component.html',
  styleUrls: ['./otras-solicitudes.component.css'],
  providers: [FormService]
})
export class OtrasSolicitudesComponent {
  public rows = [];
  public actualRow;
  public solicitudes: Condiciones_otras;
  public form;
  public matcher = new FormService();
  public esp

  constructor() {
    this.form = new FormGroup({
      demolicion: new FormControl('', Validators.required),
      instalacion: new FormControl('', Validators.required),
      instalacionGruas: new FormControl('', Validators.required),
      ejecucion: new FormControl('', Validators.required),
      otras: new FormControl('', Validators.required),
      especificar: new FormControl('', Validators.required),

      solicitud1: new FormControl('', Validators.required),
      fecha1: new FormControl('', Validators.required),
      solicitud2: new FormControl('', Validators.required),
      fecha2: new FormControl('', Validators.required),
      solicitud3: new FormControl('', Validators.required),
      fecha3: new FormControl('', Validators.required),
      solicitud4: new FormControl('', Validators.required),
      fecha4: new FormControl('', Validators.required)

    })

    if (!JSON.parse(localStorage.getItem("otras_solicitudes"))) {
      localStorage.setItem("otras_solicitudes", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("otras_solicitudes"));
      this.form.controls['demolicion'].setValue(this.rows[0] ? this.rows[0].demolicion : "");
      this.form.controls['instalacion'].setValue(this.rows[0] ? this.rows[0].instalacion : "");
      this.form.controls['instalacionGruas'].setValue(this.rows[0] ? this.rows[0].instalacionGruas : "");
      this.form.controls['ejecucion'].setValue(this.rows[0] ? this.rows[0].ejecucion : "");
      this.form.controls['otras'].setValue(this.rows[0] ? this.rows[0].otras : "");
      this.form.controls['especificar'].setValue(this.rows[0] ? this.rows[0].especificar : '');

      this.form.controls['solicitud1'].setValue(this.rows[0] ? this.rows[0].solicitud1 : "");
      this.form.controls['fecha1'].setValue(this.rows[0] ? this.rows[0].fecha1 : "");
      this.form.controls['solicitud2'].setValue(this.rows[0] ? this.rows[0].solicitud2 : "");
      this.form.controls['fecha2'].setValue(this.rows[0] ? this.rows[0].fecha2 : "");
      this.form.controls['solicitud3'].setValue(this.rows[0] ? this.rows[0].solicitud3 : "");
      this.form.controls['fecha3'].setValue(this.rows[0] ? this.rows[0].fecha3 : "");
      this.form.controls['solicitud4'].setValue(this.rows[0] ? this.rows[0].solicitud4 : "");
      this.form.controls['fecha4'].setValue(this.rows[0] ? this.rows[0].fecha4 : "");

    }
    this.solicitudes = {
      demolicion: '',
      instalacion: '',
      instalacionGruas: '',
      ejecucion: '',
      otras: '',
      especificar: '',

      solicitud1: '',
      fecha1: '',
      solicitud2: '',
      fecha2: '',
      solicitud3: '',
      fecha3: '',
      solicitud4: '',
      fecha4: ''
    };
  }

  add_condiciones() {
    console.log(this.form);
  /*   if (this.form.value.otros) {
      this.esp = this.form.value.especificar
    } else {
      this.esp = ""
    } */

    localStorage.setItem("otras_solicitudes", JSON.stringify([]));
    this.actualRow = localStorage.getItem("otras_solicitudes");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      demolicion: this.form.value.demolicion,
      instalacion: this.form.value.instalacion,
      instalacionGruas: this.form.value.instalacionGruas,
      ejecucion: this.form.value.ejecucion,
      otras: this.form.value.otras,
      especificar: this.form.value.especificar,

      solicitud1: this.form.value.solicitud1,
      fecha1: this.form.value.fecha1 ? moment(this.form.value.fecha1).format('DD/MM/YYYY') : "",
      solicitud2: this.form.value.solicitud2,
      fecha2: this.form.value.fecha2 ? moment(this.form.value.fecha2).format('DD/MM/YYYY') : "",
      solicitud3: this.form.value.solicitud3,
      fecha3: this.form.value.fecha3 ? moment(this.form.value.fecha3).format('DD/MM/YYYY') : "",
      solicitud4: this.form.value.solicitud4,
      fecha4: this.form.value.fecha4 ? moment(this.form.value.fecha4).format('DD/MM/YYYY') : "",
    })
    localStorage.setItem("otras_solicitudes", JSON.stringify(this.rows));
  }

  delete_condiciones(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("otras_solicitudes", JSON.stringify(this.rows));
      }
    }
  }

  

}
